import "./WhyCards.css"
import {Link} from "react-router-dom";

function WhyCards({ title, subTitle1, subText1, subTitle2, subText2, subTitle3, subText3, subTitle4, subText4, ctaText }) {
    return ( 
        <section className="why-cards-container">
          <h2 className="why-cards-title">{title}</h2>
          <div className="why-cards-grid hover-lift">
            <div className="why-card">
              <h3>{subTitle1}</h3>
              <p>{subText1}</p>
            </div>
            <div className="why-card">
              <h3>{subTitle2}</h3>
              <p>{subText2}</p>
            </div>
            <div className="why-card">
              <h3>{subTitle3}</h3>
              <p>{subText3}</p>
            </div>
            <div className="why-card active">
              <h3>{subTitle4}</h3>
              <p>
                {subText4}
              </p>
              <Link to="/contact" className="btn light">{ctaText}</Link>
            </div>
          </div>
        </section>
     );
}

export default WhyCards;